module.exports = __webpack_public_path__ + "static/media/visual_recs_onboarding_examples.898264a7.png";